export default "__VITE_ASSET__DPkCM2v0__"